import {
  ContentBlocks_ImageTextModule_LayoutType,
  ContentBlocks_ImageVideo,
  ContentBlocks_Position,
  ContentBlocks_Size,
  ContentBlocks_Style,
  ContentBlocks_TextAlignment,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import type {Image as GRPCImageType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import type {Video as GRPCVideoType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/video.types';
import {
  CTAStyle,
  ContentBlockMediaProps,
  ContentBlockTextTextAlignment,
  ContentBlockTextTextSize,
  ImageRatio,
  ImageType,
  VideoType,
} from '@aboutyou/ui-components';

export const fontMap: Record<ContentBlocks_Size, ContentBlockTextTextSize> = {
  [ContentBlocks_Size.XS]: 'xs',
  [ContentBlocks_Size.S]: 's',
  [ContentBlocks_Size.M]: 'm',
  [ContentBlocks_Size.L]: 'l',
  [ContentBlocks_Size.XL]: 'xl',
  [ContentBlocks_Size.UNSPECIFIED]: 's',
};

export const alignmentMap: Record<
  ContentBlocks_TextAlignment,
  ContentBlockTextTextAlignment
> = {
  [ContentBlocks_TextAlignment.START]: 'left',
  [ContentBlocks_TextAlignment.CENTER]: 'center',
  [ContentBlocks_TextAlignment.END]: 'right',
  [ContentBlocks_TextAlignment.JUSTIFY]: 'justify',
  [ContentBlocks_TextAlignment.UNSPECIFIED]: 'center',
};

export const styleMap: Record<ContentBlocks_Style, CTAStyle> = {
  [ContentBlocks_Style.UNSPECIFIED]: 'primary',
  [ContentBlocks_Style.PRIMARY]: 'primary',
  [ContentBlocks_Style.SECONDARY]: 'secondary',
  [ContentBlocks_Style.TEXT_LINK]: 'text-link',
};

type imageTextLayout = 'text-image' | 'image-text' | 'text-image';

export const imageTextLayoutMap: Record<
  ContentBlocks_ImageTextModule_LayoutType,
  imageTextLayout
> = {
  [ContentBlocks_ImageTextModule_LayoutType.UNSPECIFIED]: 'text-image',
  [ContentBlocks_ImageTextModule_LayoutType.IMAGE_TEXT]: 'image-text',
  [ContentBlocks_ImageTextModule_LayoutType.TEXT_IMAGE]: 'text-image',
};

export const horizontalPositionMap: Record<ContentBlocks_Position, string> = {
  [ContentBlocks_Position.UNSPECIFIED]: 'center',
  [ContentBlocks_Position.START]: 'start',
  [ContentBlocks_Position.CENTER]: 'center',
  [ContentBlocks_Position.END]: 'end',
};

export const transformImage = (
  grpcImageContent: GRPCImageType,
): ImageType & {aspectRatio: ImageRatio} => {
  return {
    ...grpcImageContent,
    aspectRatio: `${grpcImageContent.aspectRatio!.width}:${
      grpcImageContent.aspectRatio!.height
    }` as ImageRatio,
  };
};

export const transformVideo = (grpcVideoContent: GRPCVideoType): VideoType => {
  return {
    ...grpcVideoContent,
    aspectRatio: `${grpcVideoContent.aspectRatio!.width}:${
      grpcVideoContent.aspectRatio!.height
    }` as ImageRatio,
    fallbackImage: transformImage(grpcVideoContent.fallbackImage),
  };
};

export const transformImageVideo = (
  imageVideo: ContentBlocks_ImageVideo,
): ContentBlockMediaProps['imageOrVideo'] | null => {
  switch (imageVideo.imageOrVideo?.$case) {
    case 'image':
      return {
        $case: 'image',
        image: transformImage(imageVideo.imageOrVideo.image),
      };

    case 'video':
      return {
        $case: 'video',
        video: transformVideo(imageVideo.imageOrVideo.video),
      };

    default:
      return null;
  }
};
